import { useEffect, useState } from 'react';
import { postRequest } from '../../../../services/requestService';
import { showErrorToast } from '../../../../services/notificationsService';
import { Spinner } from '../../../../components/Spinner';

export const DealsTab = ({ organizationId }) => {
  const [stats, setStats] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchStats = async () => {
      setIsLoading(true);
      try {
        const { data } = await postRequest(
          '/backoffice/organization/get-organization-deals-stats',
          { organizationId },
        );
        setStats(data);
      } catch (error) {
        showErrorToast('Fetching stats failed');
      }
      setIsLoading(false);
    };
    fetchStats();
  }, []);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div style={{ padding: '30px' }}>
      <h3>Deal submission stats:</h3>
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: '5px' }}>
        <span>{`Total requested offers: ${stats.requestedOffers || 0}`}</span>
        <span>{`Submitted offers: ${stats.offers || 0}`}</span>
        <span>{`Offers countered by the seller: ${
          stats.counterOffers || 0
        }`}</span>
        <span>{`Accepted offers: ${stats.acceptedOffers || 0}`}</span>
        <span>{`Deals rejected by the buyer: ${
          stats.rejectedByBuyer || 0
        }`}</span>
        <span>{`The buyer did not responded: ${
          stats.didNotRespond || 0
        }`}</span>
      </div>
    </div>
  );
};
